import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ConversationApiService } from '@vendasta/conversation';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import { catchError, map, shareReplay, tap } from 'rxjs';
import { InboxService } from '../../../../../core/src';
import { StickyFooterComponent } from '../../../components/sticky-footer/sticky-footer.component';
import { getBackUrl } from '../constants';
import { WebChatInstructionsComponent } from '../web-chat-instructions/web-chat-instructions.component';

@Component({
  selector: 'inbox-show-webchat',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    GalaxyPageModule,
    TranslateModule,
    GalaxyAlertModule,
    WebChatInstructionsComponent,
    StickyFooterComponent,
  ],
  templateUrl: './show-webchat.component.html',
})
export class ShowWebchatComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly conversationApi = inject(ConversationApiService);
  private readonly inboxService = inject(InboxService);

  readonly isLoading = signal(true);
  readonly error = signal<null | string>(null);

  readonly backUrl = getBackUrl(this.inboxService.isBusinessApp, 2);

  readonly webchat$ = this.conversationApi
    .getWidget({
      widgetId: this.route.snapshot.params.widgetId,
    })
    .pipe(
      shareReplay({ bufferSize: 1, refCount: true }),
      map((widget) => widget.widget),
      catchError(async (err) => {
        this.error.set(err.message);
        return null;
      }),
      tap(() => this.isLoading.set(false)),
    );

  done(): void {
    this.router.navigate([this.backUrl], { relativeTo: this.route });
  }
}
